import { getProgress, useGetApiAdminSyncStatus } from '@sit/client-shared';

export function useSyncStatus(
  companyTreeSettingsId: number | undefined,
  onError: (error: string | null) => void,
) {
  const { data } = useGetApiAdminSyncStatus(
    {
      pathParams: {
        companyTreeSettingsId: `${companyTreeSettingsId}`,
      },
      queryParams: {
        isInitial: 'true',
      },
    },
    {
      refetchInterval: 2500,
      retry: (failureCount, error: unknown) => {
        const e = error as Error;
        onError(e.message);
        return false;
      },
      enabled: companyTreeSettingsId != null,
    },
  );
  return {
    progress: getProgress(data) || 0,
    data,
  };
}
